import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { EditFunctionChecklistProps, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const FunctionEditChecklist: React.FC<EditFunctionChecklistProps> = ({ editableDetails, setEditableDetails, handleSaveChanges, onClose }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const restrictedChars = /[\\:*?"<>|/]/;
  const handleValidationAndSave = () => {
    const name = editableDetails?.functionCheckListName?.trim();
    const description = editableDetails?.description?.trim();
    if (!name || !description) {
      setMessage(createToastMessage("Please fill all fields", "warning", 3000)); return;
    }
    if (editableDetails?.functionCheckListName.length > 60) {
      setMessage(createToastMessage("Function Checklist Name cannot exceed 60 characters", "warning", 3000));
      return;
    }
    handleSaveChanges();
  };
  const handleRestrictedInputChange = (value: string, updater: (val: string) => void) => {
    if (restrictedChars.test(value)) {
      setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
      return;
    }
    updater(value);
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edit Function Checklist</h3>
        <label>Function CheckList Name:
          <input type="text" value={editableDetails?.functionCheckListName || ""} onChange={(e) =>
            handleRestrictedInputChange(e.target.value, (val) =>
              setEditableDetails((prev: any) => ({ ...prev, functionCheckListName: val }))
            )
          } />
        </label>
        <label>Function Description:
          <textarea value={editableDetails?.description || ""} onChange={(e) =>
            handleRestrictedInputChange(e.target.value, (val) =>
              setEditableDetails((prev: any) => ({ ...prev, description: val }))
            )
          } />
        </label>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleValidationAndSave}>Save</button>
        </div>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default FunctionEditChecklist;